import React from 'react';

export const GooglePlayIcon = ({ size = 22, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3.609 1.814C3.25 2.19 3 2.784 3 3.56v16.88c0 .776.25 1.37.609 1.746l.09.09 9.5-9.5V12.5l-9.5-9.5-.09.09z" fill="#00D2FF"/>
    <path d="M16.364 15.938l-3.165-3.165V12.5l3.165-3.165.07.04 3.75 2.13c1.07.608 1.07 1.604 0 2.213l-3.75 2.13-.07.09z" fill="#FFCE00"/>
    <path d="M16.435 15.848l-3.236-3.236L3.609 22.186c.394.417 1.04.468 1.785.045l11.041-6.383z" fill="#00E676"/>
    <path d="M16.435 8.724L5.394 2.341C4.65 1.918 4.003 1.969 3.609 2.386l9.59 9.572 3.236-3.234z" fill="#FF334C"/>
  </svg>
);

export const AppleIcon = ({ size = 22, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.37c.62-.75 1.04-1.8 0.92-2.85-.9.04-1.99.6-2.63 1.35-.57.66-.99 1.73-.85 2.76 1.01.08 2.01-.51 2.56-1.26z"/>
  </svg>
);
